module.exports = __webpack_public_path__ + "img/wx.309130fd.png";